// extracted by mini-css-extract-plugin
export var box = "Card-module--box--5c522";
export var box_md = "Card-module--box_md--d4e35";
export var box_xmd = "Card-module--box_xmd--e68f5";
export var box_flex = "Card-module--box_flex--18573";
export var box_lg = "Card-module--box_lg--1a04e";
export var box_sm = "Card-module--box_sm--02088";
export var box_outer = "Card-module--box_outer--eea37";
export var box_whiteBg = "Card-module--box_white-bg--3eb2a";
export var box_noMarginBottom = "Card-module--box_no-margin-bottom--a13dc";
export var box_noPadding = "Card-module--box_no-padding--6daa3";
export var box_outerGray = "Card-module--box_outer-gray--ef8d2";
export var box_dark = "Card-module--box_dark--3a44a";
export var box_zIndex = "Card-module--box_z-index--da18c";
export var box_zIndex6 = "Card-module--box_z-index-6--3b6f4";
export var box_eventsWithLine = "Card-module--box_events-with-line--b38a1";
export var box_featuresAo = "Card-module--box_features-ao--64a30";
export var box_verticalPaddings = "Card-module--box_vertical-paddings--f79ac";
export var clearP = "Card-module--clearP--6bc13";
export var clearP_vc = "Card-module--clearP_vc--59629";
export var item = "Card-module--item--24939";
export var white = "Card-module--white--b7942";
export var black = "Card-module--black--659b7";
export var title = "Card-module--title--8a973";
export var description = "Card-module--description--b0162";
export var list = "Card-module--list--03732";
export var icon = "Card-module--icon--51be1";
export var button = "Card-module--button--e0ad0";
export var link = "Card-module--link--533ea";
export var titleMarker = "Card-module--titleMarker--db50d";
export var listItemTitle = "Card-module--listItemTitle--fa6ad";
export var listItem = "Card-module--listItem--86851";
export var fadeInAnimation = "Card-module--fadeInAnimation--68263";
export var placeHolderShimmer = "Card-module--placeHolderShimmer--6aaac";